import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
// import _get from 'lodash/get'
import Card from '../../_library/Card'
import Button from '../../_library/Button'
import {
  createEventForm,
  deleteForm,
  getEventForms,
  updateForm,
  updateFormStatus,
} from '../../../_common/core/http_services/customerForms'
import { showAxiosError, showSuccessMessage } from '../../utils/messenger'
import CustomerFormsTable from './CustomerFormsTable'
import CustomerFormModal from './CustomerFormModal'
import { FETCH_EMAIL_TEMPLATES } from '../../../_common/redux/emailtemplates/actions'
import { get_email_templates } from '../../../_common/core/selectors'

const CustomerFormComponent = props => {
  const {
    match: {
      params: { id: eventId },
    },
    FETCH_EMAIL_TEMPLATES,
    emailTemplates,
  } = props

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [customerForms, setCustomerForms] = useState([])
  const [selectedFormData, setSelectedFromData] = useState(null)
  const [emailTemplatesOption, setEmailTemplatesOption] = useState([])

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => {
    setSelectedFromData(null)
    setIsModalOpen(false)
  }

  const fetchForms = useCallback(async eventId => {
    try {
      const forms = await getEventForms(eventId)
      setCustomerForms(forms)
      closeModal()
    } catch (error) {
      showAxiosError(error)
    }
  }, [])

  const fetchEmailTemplates = useCallback(
    async eventId => {
      try {
        FETCH_EMAIL_TEMPLATES(eventId, 'event')
      } catch (error) {
        showAxiosError(error)
      }
    },
    [FETCH_EMAIL_TEMPLATES],
  )

  useEffect(() => {
    fetchForms(eventId)
    fetchEmailTemplates(eventId)
  }, [eventId, fetchEmailTemplates, fetchForms])

  useEffect(() => {
    if (
      emailTemplates?.length > 0 &&
      (emailTemplatesOption?.length === 0 || emailTemplates.length + 1 !== emailTemplatesOption.length)
    ) {
      const options = emailTemplates.map(item => ({ label: item.name, value: item.id, data: item }))
      options.unshift({ value: '', label: 'Select...' })
      setEmailTemplatesOption(options)
    }
  }, [emailTemplates, emailTemplatesOption.length])

  useEffect(() => {
    const channel = new BroadcastChannel('emailTemplates')

    const handleEmailTemplateCreated = event => {
      if (event.data.eventId === eventId) {
        fetchEmailTemplates(eventId)
      }
    }

    channel.addEventListener('message', handleEmailTemplateCreated)

    return () => {
      channel.removeEventListener('message', handleEmailTemplateCreated)
      channel.close()
    }
  }, [eventId, fetchEmailTemplates])

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (selectedFormData) {
        await updateForm(selectedFormData.id, values, eventId)
      } else {
        await createEventForm(eventId, values)
      }
      fetchForms(eventId)
      showSuccessMessage(selectedFormData ? 'Form updated successfully!' : 'Form created successfully!')

      setSubmitting(false)
      closeModal()
    } catch (error) {
      showAxiosError(error)
    }
  }

  const onFormEdit = formData => {
    setSelectedFromData(formData)
    openModal(true)
  }

  const handleFromDelete = async formId => {
    try {
      if (formId && eventId) {
        await deleteForm(formId, eventId)
        fetchForms(eventId)
        showSuccessMessage('Form deleted successfully!')
      }
    } catch (error) {
      showAxiosError(error)
    }
  }

  const handleUpdateFormSubmission = async (formDataCaptureId, status, tags) => {
    try {
      await updateFormStatus(formDataCaptureId, status, eventId, tags)
      fetchForms(eventId)
      showSuccessMessage('Submission updated successfully!')
    } catch (error) {
      showAxiosError(error)
    }
  }

  return (
    <div className="customer-form-page">
      <Card icon="fa-wpforms" title="Custom Form">
        <Button className="btn btn-success" onClick={openModal}>
          Add new form
        </Button>

        <CustomerFormsTable
          data={customerForms}
          onFormEdit={onFormEdit}
          eventId={eventId}
          handleFromDelete={handleFromDelete}
          handleUpdateFormSubmission={handleUpdateFormSubmission}
          emailTemplatesOption={emailTemplatesOption}
          fetchForms={fetchForms}
        />
        <CustomerFormModal
          eventId={eventId}
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          selectedFormData={selectedFormData}
          handleSubmit={handleSubmit}
          emailTemplatesOption={emailTemplatesOption}
        />
      </Card>
    </div>
  )
}

const mapStateToProps = state => ({
  emailTemplates: get_email_templates(state),
})

const CustomerFormCard = connect(mapStateToProps, { FETCH_EMAIL_TEMPLATES })(
  withRouter(CustomerFormComponent),
)

export default CustomerFormCard
